import Alt from 'utils/alt';
import {AltInterface} from '@store/@types/alt';

const alt = new Alt();

export default alt as AltInterface;
